import { StatusRestrictionsField, SYSTEM_OWNER_ID } from "./knowledge-base-item.types";
import { capitalizeFirstLetterAfterDot } from "utils/string";
import { GlobalEntityType } from "shared/types";
import RoutePaths from "routes/route-paths";
import { isNotEmpty } from "../../utils/validate";
export const getErrorByPropertyName = (propertyName, errors) => {
    if (errors === null) {
        return null;
    }
    const propertyNames = Array.isArray(propertyName)
        ? propertyName.map((name) => name.toLowerCase())
        : [propertyName.toLowerCase()];
    return (errors.find(({ propertyName: name }) => name !== null && propertyNames.includes(name.toLowerCase())) ??
        null);
};
export const getErrorByType = (errorType, errors) => {
    if (!errors) {
        return null;
    }
    return errors.find((error) => errorType === error.errorType);
};
export const getFieldRestrictions = (restrictions, keys) => {
    if (keys.some((k) => !isNotEmpty(k))) {
        return;
    }
    else {
        return keys.reduce((acc, key) => {
            return acc?.[key] ?? acc?.[capitalizeFirstLetterAfterDot(key)];
        }, restrictions);
    }
};
export const getRequestName = (name) => capitalizeFirstLetterAfterDot(`Request.${name}`);
export const getRestrictionDefaultValue = (restrictions, keys, attribute) => {
    const restrictionDefault = getFieldRestrictions(restrictions, keys)?.[StatusRestrictionsField.DEFAULT];
    if (Array.isArray(restrictionDefault)) {
        if (!isNotEmpty(attribute)) {
            return;
        }
        else {
            return restrictionDefault.find((item) => item?.attribute === attribute)?.value;
        }
    }
    else {
        return restrictionDefault?.value;
    }
};
export const getUnavailableEntityBackRoute = (entityType) => {
    switch (entityType) {
        case GlobalEntityType.CellModel:
            return RoutePaths.CellModels;
        case GlobalEntityType.Recipe:
            return RoutePaths.Recipes;
        case GlobalEntityType.RsWorkspace:
            return RoutePaths.RecipeScalingWorkspaces;
        case GlobalEntityType.PsWorkspace:
            return RoutePaths.PointScalingWorkspaces;
        default:
            return "";
    }
};
export const getOwnerName = (currentUserInfo, owner) => {
    if (!owner) {
        return "";
    }
    return currentUserInfo?.id === owner.id ? "You" : owner.name;
};
export const collapseOwnersList = (owners, currentUserInfo) => {
    const visibleTag = {
        id: owners[0]?.id,
        name: getOwnerName(currentUserInfo, owners[0]),
        isMoreTag: false,
    };
    const extraTags = [...owners].slice(1);
    const hiddenTagsQuantity = owners.length - 1;
    const moreTag = { name: `+${hiddenTagsQuantity}`, id: "", isMoreTag: true };
    const collapsedList = !owners.length || !isNotEmpty(visibleTag.id, true) ? [] : [visibleTag];
    if (hiddenTagsQuantity > 0) {
        collapsedList.push(moreTag);
    }
    return {
        collapsedList,
        extraTagsList: extraTags
            .filter(({ id }) => isNotEmpty(id, true))
            .map((item) => getOwnerName(currentUserInfo, item))
            .join(", "),
    };
};
export const isSampleObject = (createdBy) => createdBy?.id === SYSTEM_OWNER_ID;
export const getTagAsObject = (tag, tags) => typeof tag === "string"
    ? {
        label: tag,
        value: tag,
        removable: tags.find(({ label }) => tag === label)?.removable ?? true,
    }
    : {
        label: tag.name,
        value: tag.id,
        removable: !tag.persistent || tags.find(({ label }) => tag.name === label)?.removable,
    };
